import { useEffect } from "react";
import { Helmet } from "react-helmet-async";
import { useNavigate } from "react-router-dom";

const UGCAgenturWien = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const timer = setTimeout(() => {
      navigate("/?lang=de");
    }, 100);
    return () => clearTimeout(timer);
  }, [navigate]);

  return (
    <>
      <Helmet>
        <title>UGC Agentur Wien | AI UGC Creator Österreich | Fuel72</title>
        <meta
          name="description"
          content="UGC Agentur Wien: Professionelle AI UGC Videos für österreichische Unternehmen. UGC Creator Wien ohne Influencer. 72 Stunden Lieferung. ✓ Österreich ✓ Schnell"
        />
        <meta
          name="keywords"
          content="ugc agentur wien, ugc creator wien, ugc österreich, ai ugc wien, ugc videos wien, content creator wien, ugc werbung österreich, ugc austria"
        />
        <link rel="canonical" href="https://www.fuel72.com/ugc-agentur-wien" />
        
        {/* Hreflang */}
        <link rel="alternate" hrefLang="de" href="https://www.fuel72.com/ugc-agentur-wien" />
        <link rel="alternate" hrefLang="de-AT" href="https://www.fuel72.com/ugc-agentur-wien" />
        <link rel="alternate" hrefLang="en" href="https://www.fuel72.com/hire-ugc" />
        
        {/* Open Graph */}
        <meta property="og:title" content="UGC Agentur Wien | AI UGC Österreich | Fuel72" />
        <meta property="og:description" content="UGC Videos für österreichische Unternehmen. Wiener Charme meets AI-Technologie." />
        <meta property="og:url" content="https://www.fuel72.com/ugc-agentur-wien" />
        <meta property="og:locale" content="de_AT" />
        
        {/* Geo Tags */}
        <meta name="geo.region" content="AT-9" />
        <meta name="geo.placename" content="Wien" />
        <meta name="geo.position" content="48.208176;16.373819" />
        <meta name="ICBM" content="48.208176, 16.373819" />

        {/* Schema */}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "LocalBusiness",
            "name": "Fuel72 - UGC Agentur Wien",
            "description": "Professionelle AI UGC Videos für österreichische Unternehmen. Wien und ganz Österreich.",
            "url": "https://www.fuel72.com/ugc-agentur-wien",
            "telephone": "+4917687870011",
            "address": {
              "@type": "PostalAddress",
              "addressLocality": "Wien",
              "addressRegion": "Wien",
              "addressCountry": "AT"
            },
            "geo": {
              "@type": "GeoCoordinates",
              "latitude": "48.208176",
              "longitude": "16.373819"
            },
            "areaServed": [
              { "@type": "City", "name": "Wien" },
              { "@type": "Country", "name": "Österreich" }
            ],
            "priceRange": "€€"
          })}
        </script>
      </Helmet>

      <main className="min-h-screen gradient-mesh flex items-center justify-center">
        <div className="container mx-auto px-4 py-20 text-center">
          <h1 className="text-4xl md:text-6xl font-heading font-bold mb-6">
            UGC Agentur{" "}
            <span className="bg-gradient-to-r from-neon-purple via-neon-pink to-orange-500 bg-clip-text text-transparent">
              Wien
            </span>
          </h1>
          <p className="text-xl text-muted-foreground max-w-2xl mx-auto mb-8">
            Wiener Charme trifft AI-Innovation. 
            UGC Videos für österreichische Unternehmen.
          </p>
          
          <div className="max-w-3xl mx-auto text-left space-y-6">
            <h2 className="text-2xl font-bold">UGC für Österreich</h2>
            <p className="text-muted-foreground">
              Von der Ringstraße bis zum Prater – Wiener Unternehmen verdienen erstklassigen 
              Content. Mit Fuel72 erhalten Sie professionelle AI UGC Videos, die Ihre 
              österreichische Zielgruppe ansprechen.
            </p>
            
            <h2 className="text-2xl font-bold mt-8">Branchen in Wien & Österreich</h2>
            <ul className="space-y-2 text-muted-foreground">
              <li>☕ Kaffeehäuser & Gastronomie</li>
              <li>🎼 Kultur & Tourismus</li>
              <li>🛍️ Retail & Fashion</li>
              <li>🏥 Healthcare & Wellness</li>
              <li>🏢 B2B & Dienstleistungen</li>
            </ul>
            
            <h2 className="text-2xl font-bold mt-8">Servus, ganz Österreich!</h2>
            <p className="text-muted-foreground">
              Fuel72 bedient nicht nur Wien, sondern ganz Österreich. Ob Salzburg, Graz, 
              Innsbruck oder Linz – wir liefern AI UGC Videos in 72 Stunden.
            </p>
          </div>
          
          <p className="text-sm text-muted-foreground mt-12">Weiterleitung zur Hauptseite...</p>
        </div>
      </main>
    </>
  );
};

export default UGCAgenturWien;
